


import { ShipmentLocationController } from './controllers/shipmentLocationController';
//import '../../models/requestShipment';
//import '../../models/requestConsignee';
//import '../../models/requestPickupDetail';
import '../../models/requestDetailEdit';
import "../../../../../core/directives/readOnlyText/readOnlyTextDirective";
import './templates/shipmentLocation.scss'
export class ShipmentLocationDirective implements angular.IDirective {
    template = require('./templates/shipmentLocation.html');
    restrict = 'E';
    controller = ShipmentLocationController;
    controllerAs = 'vm';
    bindToController = {
        requestDetailEdit:"=",
        isFormRequestedFromAddNewRequest: '=',
        isLoading: '=',
        isValid: '=',
        onClickCheck: "=",
        onClickMessage: "="
    };
    scope = {};
    replace = true;
    static factory(): angular.IDirectiveFactory {
        return () => new ShipmentLocationDirective();
    }
}

angular.module('deliveryCreate.app').directive('shipmentLocation', ShipmentLocationDirective.factory());



/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/request/requestDetailEdit/directives/shipmentLocation/shipmentLocationDirective.ts
 **/